import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'whatwg-fetch'
import { Provider } from 'react-redux'
import configureStore from './store'
import getBrand from './getBrand'
import TagManager from 'react-gtm-module'
import './themes/style.scss'
import { getTagManagerId } from './helpers/tagmanager'

const store = configureStore()

const brand = process.env.REACT_APP_BRAND || getBrand()

const tagManagerArgs = {
	gtmId: getTagManagerId(brand)
}

TagManager.initialize(tagManagerArgs)

if (brand && window && window.document) {
	document.querySelector('html').setAttribute('data-brand', brand)
	window.document.body.classList.add(`theme-${brand}`)
}

ReactDOM.render(
	<Provider store={store}>
		<App brand={brand} />
	</Provider>,
	document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
